import React, { useEffect, useRef, useState } from 'react';
import Icon from '../AppIcon';

const VOCI = [
  { formato: 'csv',  label: 'Esporta CSV',   icona: 'FileText' },
  { formato: 'xlsx', label: 'Esporta Excel', icona: 'Sheet' },
  { formato: 'pdf',  label: 'Esporta PDF',   icona: 'FileDown' },
];

/**
 * Menu "Esporta" (CSV / Excel / PDF).
 * onEsporta(formato) deve restituire una Promise; durante l'esportazione il pulsante è disabilitato.
 */
const ExportMenu = ({ onEsporta, disabilitato = false, inCorso = false }) => {
  const [aperto, setAperto] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => {
      if (!ref.current?.contains(e.target)) setAperto(false);
    };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setAperto((o) => !o)}
        disabled={disabilitato || inCorso}
        className="flex items-center gap-2 px-4 py-2.5 bg-muted/40 hover:bg-muted/80 border border-border/40 hover:border-primary/30 rounded-2xl text-[11px] font-black uppercase tracking-widest text-muted-foreground hover:text-foreground transition-all duration-200 shadow-sm disabled:opacity-50"
      >
        <Icon name={inCorso ? 'Loader2' : 'Download'} size={14} className={inCorso ? 'animate-spin' : ''} />
        <span className="hidden sm:inline">{inCorso ? 'Esportazione...' : 'Esporta'}</span>
        <Icon name="ChevronDown" size={12} className={`transition-transform duration-200 ${aperto ? 'rotate-180' : ''}`} />
      </button>

      {aperto && (
        <div className="absolute right-0 top-full mt-2 w-48 bg-card border-2 border-border/60 rounded-2xl shadow-2xl overflow-hidden z-20 animate-in fade-in zoom-in-95 duration-150">
          {VOCI.map((v) => (
            <button
              key={v.formato}
              type="button"
              onClick={() => {
                setAperto(false);
                onEsporta(v.formato);
              }}
              className="w-full flex items-center gap-3 px-4 py-3 text-[12px] font-bold text-foreground/70 hover:text-foreground hover:bg-primary/5 transition-all duration-150 border-b border-border/20 last:border-0"
            >
              <Icon name={v.icona} size={14} className="text-primary/60" />
              {v.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExportMenu;
